module.exports = __webpack_public_path__ + "img/pn.2d4ce20.svg";